<script>

import {headerState} from "@/stores/headerStore.js";
import {BButton, BIcon} from "buefy";
import TrainingsProgress from "@/components/trainings/TrainingsProgress.vue";
import CertificateDownloadButton from "@/components/trainings/CertificateDownloadButton.vue";

export default {
    components: {CertificateDownloadButton, BButton, TrainingsProgress, BIcon},
    data() {
        return {
            training: null,
            loading: true,
        }
    },
    methods: {
    },
    computed: {
        isCompleted() {
            return this.training.trainings.filter(t => !t.is_opened).length === 0
        }
    },
    mounted() {
        axios.get('/trainings/' + this.$route.params.id).then((response) => {
            this.training = response.data.data;
            headerState.title = this.training.name;
        }).catch(() => {
        }).finally(() => {
            this.loading = false;
        })
    },
}

</script>
<template>
    <div class="trainings-show">

        <loader :loading="loading"></loader>
        <div v-if="!loading">

            <TrainingsProgress
                v-if="$auth.isEmployee() && training.trainings && training.trainings.length"
                :trainings="training.trainings"
            />

            <div class="mb-4 certificate-btn">
                <CertificateDownloadButton v-if="$auth.isEmployee() && isCompleted" :training="training"/>
            </div>

            <div class="mb-4 training-description">
                {{ training.description }}
            </div>

            <nav class="panel">

                <router-link :to="{name: 'training-series.show-training', params: {id: training.id, training_id: _training.id}}"
                             class="panel-block"
                             v-for="_training in training.trainings"
                             :key="_training.id">
                    <span class="panel-icon">
                        <b-icon v-if="_training.is_opened"
                                icon="check-circle-outline"
                                size="is-small"
                                class="has-text-success"/>
                        <b-icon v-else icon="circle-outline" size="is-small"/>
                    </span>
                    {{ _training.name }}
                </router-link>

            </nav>
        </div>
    </div>
</template>

<style scoped>
.training-description {
    white-space: pre-line;
}
.certificate-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
